<div *ngIf="vm.params.type !== 'pre-visit'">
  <symptom-check-results-pay [interview]="vm.interview"></symptom-check-results-pay>
</div>
<div *ngIf="vm.params.type === 'pre-visit'">
  <symptom-check-results-pre-visit [interview]="vm.interview" [settings]="vm.config" [problemDescription]="vm.problemDescription"></symptom-check-results-pre-visit>
</div>
